<template>
  <div class="container preview-modal" v-bind:class="{ maximized: maximized === true || mobile }">
    <modal :name="name" @before-open="beforeOpen" @before-close="beforeClose">
      <!-- Top Bar -->
      <div class="top-bar">
        <div class="right-buttons">
          <button v-if="!mobile" @click="toggleMaximize()" class="preview-modal-button maximize-button" v-bind:class="{ maximized: maximized === true }">
            <svg fill="#FFFFFF" width="16px" height="16px" enable-background="new 0 0 384 384" version="1.1" viewBox="0 0 384 384" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
              <path d="m373.33 0h-234.67c-5.896 0-10.667 4.771-10.667 10.667s4.771 10.667 10.667 10.667h208.92l-344.46 344.46c-4.167 4.167-4.167 10.917 0 15.083 2.083 2.083 4.813 3.125 7.542 3.125s5.458-1.042 7.542-3.125l344.46-344.46v208.92c0 5.896 4.771 10.667 10.667 10.667s10.667-4.771 10.667-10.667v-234.67c-1e-3 -5.896-4.772-10.667-10.668-10.667z"/>
            </svg>
          </button>
          <button @click="closeModal" class="preview-modal-button">
            <svg width="16px" height="16px" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs></defs>
              <g id="Home-page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Menu" transform="translate(-1530.000000, -40.000000)" fill="#FFFFFF">
                  <path d="M1545.8,54.2 L1564.20098,54.2 C1564.64227,54.2 1565,54.5550919 1565,55 C1565,55.4418278 1564.64198,55.8 1564.20098,55.8 L1545.8,55.8 L1545.8,74.2009848 C1545.8,74.6422687 1545.44491,75 1545,75 C1544.55817,75 1544.2,74.6419794 1544.2,74.2009848 L1544.2,55.8 L1525.79902,55.8 C1525.35773,55.8 1525,55.4449081 1525,55 C1525,54.5581722 1525.35802,54.2 1525.79902,54.2 L1544.2,54.2 L1544.2,35.7990152 C1544.2,35.3577313 1544.55509,35 1545,35 C1545.44183,35 1545.8,35.3580206 1545.8,35.7990152 L1545.8,54.2 Z" id="Combined-Shape" transform="translate(1545.000000, 55.000000) rotate(-315.000000) translate(-1545.000000, -55.000000) "></path>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </div>

      <div class="preview-modal__content">
        <!-- Default Slot -->
        <slot v-if="value.type === 'default'"></slot>
        <!-- Pdf preview -->
        <pdf-preview
          v-if="value.type === 'pdf'"
          :url="value.medias.local">
        </pdf-preview>

        <!-- Video preview -->
        <vt-video
          v-if="value.type === 'video'"
          :videos="value.medias"
          :poster="value.poster"
           autoplay
           lazyload
          :auto-size="false"
          :preferr="value.preferr">
        </vt-video>
      </div>

    </modal>
  </div>
</template>

<script>

export default {
  name: 'nt-modal',
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      value: {
        type: 'default',
        poster: '',
        preferr: '',
        customsize: false,
        medias: {
          youtube: '',
          youku: '',
          local: ''
        }
      },
      maximized: false,
      mobile: true,
      maxWidth: 1024
    }
  },
  watch: {
    mobile(mobile) {
      this.maximized = mobile
    }
  },
  created() {
    this.checkmobile()

    this.$root.$on('openmodal', (payload) => {
      const name = payload && payload.name ? payload.name : 'default'

      if (payload) {
        Object.assign(this.value, payload)
      }
      this.$modal.show(name)
    })
    window.addEventListener('resize', this.checkmobile, false)
  },
  methods: {
    closeModal() {
      this.maximized = false
      this.value = {
        type: 'default',
        data: null
      }
      this.$modal.hide(this.name)
    },
    beforeOpen() {
      document.body.classList.add('modal-opened')
    },
    beforeClose() {
      document.body.classList.remove('modal-opened')
    },
    toggleMaximize() {
      this.maximized = !this.maximized
    },
    checkmobile() {
      const isMobile = window.innerWidth <= this.maxWidth

      if (isMobile === this.mobile) return

      this.mobile = isMobile
    }
  }
}
</script>
